import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Determine the user type based on the user's login status and if they are a Swoosh user for fulfillment offerings
 * @returns {Promise<string>} - Promise string representing the user type
 */
var determineUserType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var isLoggedIn, isSwoosh, userType;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return window.webShellClient.identity.getIsLoggedIn();
        case 1:
          isLoggedIn = _context.sent;
          _context.next = 2;
          return window.webShellClient.identity.getIsSwooshUser();
        case 2:
          isSwoosh = _context.sent;
          userType = 'nike:guest';
          if (isLoggedIn) {
            userType = 'nike:plus';
          }
          if (isSwoosh) {
            userType = 'nike:swoosh';
          }
          return _context.abrupt("return", userType);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function determineUserType() {
    return _ref.apply(this, arguments);
  };
}();
export default determineUserType;